import React from 'react';
interface TrustBadgeProps {
  icon: React.ReactNode;
  text: string;
}
export function TrustBadge({
  icon,
  text
}: TrustBadgeProps) {
  return <div className="flex items-center gap-3 p-4 bg-crown-surface border border-crown-border rounded-lg" data-id="element-125">
      <div className="text-crown-red flex-shrink-0" data-id="element-126">{icon}</div>
      <span className="text-sm text-crown-body font-medium" data-id="element-127">{text}</span>
    </div>;
}